class Contacto {
    constructor(contactoId, fecha, vendedorEmail, cliente, direccion, codPostal, poblacion, provincia, pais, telefono, email, modelo, observaciones, condiciones, createdAt, updatedAt, usuarioId, feriaId) {
        this.contactoId = contactoId;
        this.fecha = fecha;
        this.vendedorEmail = vendedorEmail;
        this.cliente = cliente;
        this.direccion = direccion;
        this.codPostal = codPostal;
        this.poblacion = poblacion;
        this.provincia = provincia;
        this.pais = pais;
        this.telefono = telefono;
        this.email = email;
        this.modelo = modelo;
        this.observaciones = observaciones;
        this.condiciones = condiciones;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.usuarioId = usuarioId;
        this.feriaId = feriaId;
    }
}

class UserWithContacts {
    constructor(idusuario, email, contraseña, createdAt, updatedAt, permisos, contactos = []) {
        this.idusuario = idusuario;
        this.email = email;
        this.contraseña = contraseña;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.permisos = permisos;
        this.contactos = contactos.map(contacto => new Contacto(
            contacto.contactoId,
            contacto.fecha,
            contacto.vendedorEmail,
            contacto.cliente,
            contacto.direccion,
            contacto.codPostal,
            contacto.poblacion,
            contacto.provincia,
            contacto.pais,
            contacto.telefono,
            contacto.email,
            contacto.modelo,
            contacto.observaciones,
            contacto.condiciones,
            contacto.createdAt,
            contacto.updatedAt,
            contacto.usuarioId,
            contacto.feriaId
        ));
    }
}

export default UserWithContacts;
